import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { pt } from 'vuetify/lib/locale'
import { en } from 'vuetify/lib/locale'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: {
      ptbr: pt,
      en
    },
    current: 'ptbr'
  },
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#014373', //header e botões #2b3985
        primary_sidebar_titles: '#000000', //títulos do menu lateral de navegação
        primary_title: '#000000', //títulos dos módulos
        primary_hiperlink: '#014373', //cor do hiperlink abaixo do título dos módulos
        primary_filter_title: '#000000', //título dos filtros
        primary_table_title: '#000000', //título da tabela
        primary_table_header: '#595959', //cabeçalho das tabelas
        primary_table_text: '#595959', //textos no interior das tabelas
        primary_details_titles: '#000000', //todos os títulos dos componentes presentes nas telas de "...Details.vue"
        primary_card_background: '#d4efdf' ,
        positive_change: '#28a745',
        negative_change: '#e74c3c',
        secondary: '#FFFFFF', //hamburger
        gray: '#F7F7F7',
        lightGray: '#EFEFEF',
        black: '#101828',
        mediumGray: '#959595',
        darkGray: '#9E9E9E',
        important: '#FB3A04',
        lightImportant: '#FEF2F2',
        white: '#ffffff',
        accent: '#4CAF50',
        error: '#f59a9a'
      }
    }
  }
})
